import React, { useEffect, useState } from "react";
import { Button, Paper, CircularProgress } from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import BackspaceIcon from '@material-ui/icons/Backspace';
import { Link, useHistory, useParams, Outlet } from "react-router-dom";
import { SOW_INFO_OPTION, VendorUpdateData } from "../../constants/updateVendorConstants";
import './UpdateVendorProfiles.scss';
import { PromptProvider } from "components/Modal/PromptProvider";
import { usePrompt } from "components/Modal/usePrompt";
import { notification } from "antd";
import axios from "axios";

const UpdateVendorProfile = ({ bodyContent }) => {
  const [active, activateSection] = React.useState(bodyContent || SOW_INFO_OPTION)
  const { gstn } = useParams();
  const history = useHistory();
  const prompt = usePrompt();
  const [isValidGstn, setIsValidGstn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPlatform, setIsPlatform] = useState(null);

  const navigateToVendors = () => {
    history.replace('/vendors')
  }

  const clearFilters = () => {
    sessionStorage.removeItem('searchParams');
    history.replace('/vendors')
  }

  function validateGST(gstn) {
    let regTest = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(
      gstn
    );
    return regTest;
  }

  //To remove the tracker from session storage on reload
  useEffect(() => {
    window.addEventListener("beforeunload", () => {
      sessionStorage.removeItem("hasShownGstnError");
      sessionStorage.removeItem(`isPlatform_${gstn}`);
    });
    return () => window.removeEventListener("beforeunload", () => {
      sessionStorage.removeItem("hasShownGstnError");
      sessionStorage.removeItem(`isPlatform_${gstn}`);
    });
  }, []);

  useEffect(() => {
    const isValid = validateGST(gstn);
    setIsValidGstn(isValid);
    const hasShownNotification = sessionStorage.getItem("hasShownGstnError");
    const storedIsPlatform = sessionStorage.getItem(`isPlatform_${gstn}`);
    if (storedIsPlatform!==null && storedIsPlatform !== 'false' && isValid) {
      setLoading(false);
      setIsPlatform(true);
    } else {
      if(storedIsPlatform === 'false'){
        if(!hasShownNotification){
        notification.error({
          top: 70, duration: 4, message: "GSTN is invalid/non-platform"
        });
      }
        sessionStorage.setItem("hasShownGstnError", "true");
        setIsPlatform(false);
        setLoading(false);
      }else{
        checkIsPlatformVendor();
      }
    }
  }, [gstn]);

  const checkIsPlatformVendor = async () => {
    try {
      const result = await axios.get(`${process.env.REACT_APP_API_URL}/v1/vendor-profile/Is-platform-vendor?gstn=${gstn}`);
      if (result.data) {
        sessionStorage.setItem(`isPlatform_${gstn}`, JSON.stringify(true));
        setIsPlatform(true);
        setLoading(false);
      } else {
        notification.error({
          top: 70, duration: 4, message: "GSTN is invalid/non-platform"
        });
        setIsPlatform(false);
        sessionStorage.setItem("hasShownGstnError", "true");
        sessionStorage.setItem(`isPlatform_${gstn}`, JSON.stringify(false));
        setLoading(false);
      }
    } catch (error) {
      console.log("Error checking platform vendor:", error);
    } 
  };

  return (
    <PromptProvider>
    <div className="row update_vendor_container">

      <Paper className="col-3 collections_card" elevation={2}>
        <Button variant="contained" className="back_button mb-4" color="primary" onClick={navigateToVendors}>
          <ArrowBackIcon className="back_arrow"></ArrowBackIcon>
          Back
        </Button>
        {VendorUpdateData ? VendorUpdateData.map(menu => (
          <Link
            key={menu.id}
            to={menu.linkTo + "/" + gstn}
            className={
              active && active.linkTo === menu.linkTo ? "active" : ""
            }
            style={{
              display: "block",
              padding: "15px 13px",
              background:
                active && active.linkTo === menu.linkTo
                  ? "#F4F6FF"
                  : "transparent",
            }}
          >
            <div className="selector_area" onClick={() => {
              prompt.isDataChanged && activateSection(menu)
            }}>
              {menu.cardName}
            </div>
          </Link>
        )) : null}
        <Button variant="contained" className="clear_filter mt-4" color="primary" onClick={clearFilters}>
          <BackspaceIcon className="back_arrow"></BackspaceIcon>
           (Back) Without Filters
        </Button>
      </Paper>
      <Paper className="col-8 collections_card ml-5 d-flex" style={{ flexDirection: "column" }} elevation={2}>
          {loading ? (
            <div className="loading-container">
              <CircularProgress color="primary" />
              <p>Loading vendor details...</p>
            </div>
          ) : (
            isValidGstn && isPlatform && active ? active.render() : null
          )}
        </Paper>
    </div>
    </PromptProvider>
  )
}

export default UpdateVendorProfile;